import axios from "axios";
import { toast } from "./toast";

const DEFAULT_MESSAGES: Record<number, string> = {
400: "Bad Request",
401: "Unauthorized. Please login again.",
403: "Access denied.",
404: "Resource not found.",
409: "This action could not be completed.",
500: "Internal server error.",
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const backendMessage = error.response?.data?.message;

    // 500s often carry raw exception text, not meant for end users —
    // always show the generic message regardless of what the backend sent.
    const errorMessage =
      status === 500
        ? DEFAULT_MESSAGES[500]
        : backendMessage || DEFAULT_MESSAGES[status] || "Something went wrong";

    toast("error", errorMessage);

    return Promise.reject(error);
  }
);